// Helpers de dates : ISO (AAAA-MM-JJ) ↔ affichage (JJ/MM/AAAA), masque de saisie, validation.

export function daysInMonth(year: number, month: number): number {
  return new Date(year, month, 0).getDate();
}

export function isValidDate(value: string): boolean {
  if (!value || value.length < 10) return false;
  const parts = value.slice(0, 10).split("-");
  if (parts.length !== 3) return false;
  const year = parseInt(parts[0], 10);
  const month = parseInt(parts[1], 10);
  const day = parseInt(parts[2], 10);
  if (isNaN(year) || isNaN(month) || isNaN(day)) return false;
  if (year < 2000 || year > 2100) return false;
  if (month < 1 || month > 12) return false;
  if (day < 1 || day > daysInMonth(year, month)) return false;
  return true;
}

export function fixYear(value: string): string {
  if (!value || value.length < 10) return value;
  const parts = value.slice(0, 10).split("-");
  if (parts.length !== 3) return value;
  const year = parseInt(parts[0], 10);
  if (isNaN(year) || year >= 2000) return value;
  return `${year + 2000}-${parts[1]}-${parts[2]}`;
}

export function displayToIso(display: string): string {
  const clean = display.replace(/\s/g, "");
  if (clean.length !== 10) return "";
  const parts = clean.split("/");
  if (parts.length !== 3) return "";
  const [dd, mm, yyyy] = parts;
  if (dd.length !== 2 || mm.length !== 2 || yyyy.length !== 4) return "";
  return `${yyyy}-${mm}-${dd}`;
}

export function isoToDisplay(iso: string): string {
  if (!iso || iso.length < 10) return "";
  const parts = iso.slice(0, 10).split("-");
  if (parts.length !== 3) return "";
  return `${parts[2]}/${parts[1]}/${parts[0]}`;
}

export function applyDateMask(raw: string): string {
  const digits = raw.replace(/\D/g, "").slice(0, 8);
  let result = "";
  for (let i = 0; i < digits.length; i++) {
    if (i === 2 || i === 4) result += "/";
    result += digits[i];
  }
  return result;
}

export function dayBefore(dateStr: string): string {
  // Parse manuellement pour éviter le décalage UTC/local
  const [year, month, day] = dateStr.slice(0, 10).split("-").map(Number);
  const d = new Date(year, month - 1, day); // date locale, pas UTC
  d.setDate(d.getDate() - 1);
  const yy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  return `${yy}-${mm}-${dd}`;
}

export function todayStr(): string {
  return new Date().toISOString().slice(0, 10);
}

export function monthAgoStr(): string {
  const d = new Date();
  d.setMonth(d.getMonth() - 1);
  return d.toISOString().slice(0, 10);
}

export function handleDateFromChange(
  value: string,
  dateTo: string,
  setDateFrom: (v: string) => void,
  setDateTo: (v: string) => void,
): void {
  if (!value) {
    setDateFrom("");
    return;
  }
  const fixed = fixYear(value);
  if (!isValidDate(fixed)) {
    setDateFrom("");
    return;
  }
  const today = new Date().toISOString().slice(0, 10);
  const capped = fixed > today ? today : fixed;
  setDateFrom(capped);
  if (dateTo && capped > dateTo) setDateTo("");
}

export function handleDateToChange(
  value: string,
  dateFrom: string,
  setDateTo: (v: string) => void,
): void {
  if (!value) {
    setDateTo("");
    return;
  }
  const fixed = fixYear(value);
  if (!isValidDate(fixed)) {
    setDateTo("");
    return;
  }
  const today = new Date().toISOString().slice(0, 10);
  const capped = fixed > today ? today : fixed;
  if (dateFrom && capped < dateFrom) return;
  setDateTo(capped);
}
